module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/Dashboard/DashboardPages/System settings/payment/payment.component.scss
// module id = ./src/app/Dashboard/DashboardPages/System settings/payment/payment.component.scss
// module chunks = main